
import { Box, useToast, Text, Skeleton, Stack } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import Form from "./Form";
import { useEffect, useRef, useState } from "react";
import {
  getVendorDetails,
  updateVendorDetails,
} from "../../../actions/inventory/vendor.action";
import { useParams, useNavigate } from "react-router-dom";
import vendorValidationSchema from "./validation.jsx";

const EditVendor = () => {
  const [data, setData] = useState();
   const { id } = useParams();
  const params = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const formRef = useRef();


  // console.log("eri  id:",id);
  
  const handleSubmit = async (values) => {
    // console.log("Updating vendor with values:", values);
    
    try {
      const myformData = new FormData(formRef.current);

      // ✅ Clear vendorContacts from FormData to avoid duplicates
      myformData.delete("vendorContacts");

      // Handle image fields - only include if new files are uploaded
      const imgFields = [
        "aadhaarCardBack",
        "aadhaarCardFront",
        "panCardFront",
        "companyPanCardFront",
        "ownerPanCardFront",
        "gstCertificate",
      ];

      imgFields.forEach(field => {
        const fileInput = formRef.current[field];
        if (fileInput && fileInput.files.length > 0) {
          myformData.set(field, fileInput.files[0]);
        } else {
          myformData.delete(field);
        }
      });

      // ✅ Add all non-file form values
      Object.keys(values).forEach((key) => {
        if (key === "vendorContacts" || imgFields.includes(key)) {
          return; // Skip already handled fields
        }
        if (values[key] !== undefined && values[key] !== null && values[key] !== "") {
          myformData.set(key, values[key]);
        }
      });

      // ✅ CRITICAL: Always send vendorContacts (even if empty array)
      if (values.vendorType === "organisation") {
        const validContacts = values.vendorContacts?.filter(
          contact => contact.name || contact.email || contact.mobile
        ) || [];
        
        // ✅ Send empty array if all contacts deleted
        myformData.append("vendorContacts", JSON.stringify(validContacts));
      } else {
        // ✅ For individual, send empty array to clear contacts
        myformData.append("vendorContacts", JSON.stringify([]));
      }

      // console.log("=== Edit FormData ===");
      // for (let [k, v] of myformData.entries()) {
      //   console.log(k, v instanceof File ? v.name : v);
      // }

      const res = await updateVendorDetails(id, myformData);
      
      toast({
        title: "Success",
        description: "Vendor details updated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      
      navigate("/fleet-management/vendor");
      
    } catch (error) {
      console.error("Error updating vendor:", error);
      
      toast({
        title: "Error",
        description: error?.response?.data?.message || error.message || "Failed to update vendor details",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

const loadDetails = async () => {
  try {
    const { data: vendorData } = await getVendorDetails(id);
    // console.log("Vendor data loaded:", vendorData);
    setData({
      ...vendorData,
      vendorContacts: vendorData?.vendorContacts?.length
        ? vendorData.vendorContacts
        : [],
    });

    // console.log("Set data :", data); 
  } catch (error) {
    console.error(error);
  }
};

useEffect(() => {
  loadDetails();
}, [id]);

  if (!data) {
    return (
      <Box w={"100%"} p={6}>
        <Stack spacing={4}>
          <Skeleton height="40px" />
          <Skeleton height="300px" />
        </Stack>
      </Box>
    );
  }

  return (
    <Box w={"100%"} justifyContent={"center"} spacing={10} p={6}>
      <BreadCrumbMaker
        items={[
          { link: "", title: "Fleet Management" },
          { link: "/fleet-management/vendor", title: "Vendor" },
          { link: "", title: "Edit Vendor", on: true },
        ]}
      />
      <Form
        data={data}
        setData={setData}
        handleSubmit={handleSubmit}
        formRef={formRef}
        validationSchema={vendorValidationSchema}
      />
    </Box>
  );
};

export default EditVendor;